import { InventoryItem, InventoryProperty, InventoryType } from "../../../api/inventory.models";

export const getInventoryItems = (inventoryTypes: InventoryType[]) => {
	return inventoryTypes?.flatMap(type => type.InventoryCategories.flatMap(cat => cat.InventoryItems) ?? []) ?? [];
}

export const getInventoryPropertyValue = (inventoryItem: InventoryItem, inventoryProperty: InventoryProperty) => {
	var value = inventoryItem.InventoryPropertyValues.find(v => v.InventoryPropertyId === inventoryProperty.Id);
	return value != null ? value.Value != null ? value.Value : "" : "N/A";
}